export default __webpack_public_path__ + "static/deran-campus-63a6b51d2d23bcbb89b951f07d8f75ba.jpeg";